import React from 'react';
import { FaSortAmountDown, FaCoins } from 'react-icons/fa';
import { ReceiptFrequencyRanking } from '../../types';

interface RankingTablesProps {
  rankings: ReceiptFrequencyRanking;
}

const DAY_LABELS: Record<string, string> = {
  Monday: 'Lunes', Tuesday: 'Martes', Wednesday: 'Miércoles',
  Thursday: 'Jueves', Friday: 'Viernes', Saturday: 'Sábado', Sunday: 'Domingo',
};

const RANK_CLASS = ['', 'mp-rank-gold', 'mp-rank-silver', 'mp-rank-bronze'];

const RankingTables: React.FC<RankingTablesProps> = ({ rankings }) => {
  const fmtCurrency = (v: number) => `$${v.toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;

  const topFreq = rankings.byFrequency.slice(0, 10);
  const topAmt = rankings.byTotalAmount.slice(0, 10);

  const renderTable = (
    icon: React.ReactNode, title: string, data: typeof topFreq,
    valueLabel: string, renderValue: (entry: typeof topFreq[0]) => React.ReactNode
  ) => (
    <div className="mp-table-card">
      <div className="flex items-center gap-3 px-5 py-3.5 border-b" style={{ borderColor: 'var(--border-color)' }}>
        {icon}
        <span className="text-sm font-bold" style={{ color: 'var(--strong-color)' }}>{title}</span>
      </div>
      <div className="overflow-auto" style={{ maxHeight: 520 }}>
        <table className="mp-table" style={{ width: '100%' }}>
          <thead className="mp-table-head">
            <tr>
              <th style={{ width: 52, textAlign: 'center' }}>#</th>
              <th>Día</th>
              <th>Hora</th>
              <th style={{ textAlign: 'right' }}>{valueLabel}</th>
            </tr>
          </thead>
          <tbody className="mp-table-body">
            {data.map((entry, i) => (
              <tr key={i} style={{ background: i % 2 === 1 ? 'var(--background-color)' : 'transparent' }}>
                <td style={{ textAlign: 'center' }}>
                  <span className={`mp-rank-badge ${RANK_CLASS[i + 1] || ''}`}>{i + 1}</span>
                </td>
                <td style={{ fontWeight: 500, color: 'var(--text-color)' }}>{DAY_LABELS[entry.day]}</td>
                <td style={{ color: 'var(--text-color)', opacity: 0.55, fontFamily: "'SF Mono', 'Fira Code', monospace", fontSize: '0.8125rem' }}>{entry.hourRange}:00</td>
                <td style={{ fontWeight: 700, color: '#FC7556', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{renderValue(entry)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {renderTable(
        <FaSortAmountDown style={{ color: '#FC7556' }} />,
        'Top 10 — Mayor Frecuencia', topFreq, 'Recibos',
        (e) => e.count
      )}
      {renderTable(
        <FaCoins style={{ color: '#F59E0B' }} />,
        'Top 10 — Mayor Ingreso', topAmt, 'Monto',
        (e) => fmtCurrency(e.totalAmount)
      )}
    </div>
  );
};

export default RankingTables;
